var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutofRange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 14",
    opacity: 0.2,
    cx: 8,
    cy: 8.5,
    r: 8,
    fill: "#CE4954"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 11",
    cx: 8,
    cy: 8.5,
    r: 4,
    fill: "#CE4954"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutofRange);
export default __webpack_public_path__ + "static/media/OutofRange.fcafa2b63388cbd0a6265aed0b2c6197.svg";
export { ForwardRef as ReactComponent };